import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { MeasurementDataShahiCarharttEntity } from "../dto/color-carhartt.entity";


@Injectable()
export class ColorCarharttRepository extends Repository<MeasurementDataShahiCarharttEntity> {

    constructor(@InjectRepository(MeasurementDataShahiCarharttEntity) private ColorCarharttRepo: Repository<MeasurementDataShahiCarharttEntity>
    ) {
        super(ColorCarharttRepo.target, ColorCarharttRepo.manager, ColorCarharttRepo.queryRunner);
    }

}